import { getConfigForAppdomain } from '../../../config';
import { getFromSdk } from './utils';

const CAMPAIGN_GROUP_PREFIX = 'upcoming_campaigns_';

const getCampaignTagGroup = (appdomainId) => {
    const config = getConfigForAppdomain(appdomainId) || {};

    return `${CAMPAIGN_GROUP_PREFIX}${appdomainId}${config.notificationTagSufix || ''}`;
};

export const getCampaignTags = async (appdomainId) => {
    const tagList = await getFromSdk('channel.tags.list', {});

    return tagList[getCampaignTagGroup(appdomainId)] || [];
};

export const removeCampaignTag = async (campaignIdentifier, appdomainId) => {
    const tags = await getFromSdk('channel.tags');

    try {
        return await tags.remove(
            `${campaignIdentifier}`,
            getCampaignTagGroup(appdomainId)
        );
    }
    catch (e) {
        return null;
    }
};

export const addCampaignTag = async (campaignIdentifier, appdomainId) => {
    const tags = await getFromSdk('channel.tags');

    if (!campaignIdentifier) {
        return null;
    }

    try {
        return await tags.add(
            `${campaignIdentifier}`,
            getCampaignTagGroup(appdomainId)
        );
    }
    catch (e) {
        return null;
    }
};
